import React from 'react';
import { translateData } from 'utils/translation';
import { Span } from 'components/Ui';
import styles from './styles.scss';

function Bottom() {
  const phone = translateData('PhoneNumber:Moving');
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Span>
          Moving? Take us with you. Call us for service availability at your new
          location.
        </Span>
        <a href={`tel:${phone}`} className={styles.phone}>
          {phone}
        </a>
      </div>
    </div>
  );
}

export default Bottom;
